import { EntitiesState } from '@redux/entities'

import type { CampaignQuoteTemplateItemModel } from '@models/types'

type BuildFavouriteOrderParams = {
  campaignId: number,
  campaignQuoteId?: number,
  campaignQuoteTemplateId?: number,
  favouriteOrderId: number,
  favouriteOrders: EntitiesState['favouriteOrders'],
  quoteSectionId?: number,
  redirect?: string,
}

const buildFavouriteOrder = (params: BuildFavouriteOrderParams) => {
  const {
    campaignId,
    campaignQuoteId,
    campaignQuoteTemplateId,
    favouriteOrderId,
    favouriteOrders,
    quoteSectionId,
    redirect,
  } = params

  const favouriteOrder = favouriteOrders[favouriteOrderId]

  // Quote Item
  if (campaignQuoteId || campaignQuoteTemplateId){
    const payload: Partial<CampaignQuoteTemplateItemModel> = {
      // @ts-expect-error TS2353
      campaign_quote_id: undefined,
      campaign_quote_section_id: undefined,
      campaign_quote_template_id: undefined,
      campaign_quote_template_section_id: undefined,
      favourite_order_id: favouriteOrder.id,
      item_type: 'orderable',
      title: favouriteOrder.title,
    }

    // Quote
    if (campaignQuoteId){
      // @ts-expect-error TS2339
      payload.campaign_quote_id = campaignQuoteId
      // @ts-expect-error TS2339
      payload.campaign_quote_section_id = quoteSectionId
    }

    // Quote Template
    if (campaignQuoteTemplateId){
      payload.campaign_quote_template_id = campaignQuoteTemplateId
      payload.campaign_quote_template_section_id = quoteSectionId
    }

    return {
      itemType: campaignQuoteTemplateId ? 'quoteTemplateItem' : 'quoteItem',
      payload,
      redirect,
    }
  }

  // Order
  return {
    itemType: 'order',
    payload: {
      campaignId,
      favouriteOrderId: favouriteOrder.id,
    },
    redirect,
  }
}

export type BuildFavouriteOrderPayload = ReturnType<typeof buildFavouriteOrder>

export default buildFavouriteOrder
